let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3GliG")).then(() => parcelRequire('3E6Ib'));